import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-sp',
  templateUrl: './footer-sp.component.html',
  styleUrls: ['./footer-sp.component.less'],
})
export class FooterSpComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
